import { SVGProps } from "react";

// Spider / crawler glyph, used as the Indexing nav icon. Sized in em and stroked
// with currentColor so it follows the fontSize/color the nav hands its icons
// (16px open, 20px collapsed) instead of being pinned to the 14px Figma export.
export default function SpiderIcon({
  width = "1em",
  height = "1em",
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.91663 2.33334V3.50001L5.83329 6.41668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.45837 5.54166L2.33337 6.41666H5.83337"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33337 11.0834V9.91669L5.83337 6.41669"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0833 2.33334V3.50001L8.16663 6.41668"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5416 5.54166L11.6666 6.41666H8.16663"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6666 11.0834V9.91669L8.16663 6.41669"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.35004 10.3999C4.91246 9.96235 4.66663 9.36886 4.66663 8.75002C4.66663 8.13118 4.91246 7.53769 5.35004 7.1001C5.78763 6.66252 6.38112 6.41669 6.99996 6.41669C7.6188 6.41669 8.21229 6.66252 8.64988 7.1001C9.08746 7.53769 9.33329 8.13118 9.33329 8.75002C9.33329 9.36886 9.08746 9.96235 8.64988 10.3999C8.21229 10.8375 7.6188 11.0834 6.99996 11.0834C6.38112 11.0834 5.78763 10.8375 5.35004 10.3999Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83337 5.25001C5.83337 5.55943 5.95629 5.85618 6.17508 6.07497C6.39388 6.29376 6.69062 6.41668 7.00004 6.41668C7.30946 6.41668 7.60621 6.29376 7.825 6.07497C8.04379 5.85618 8.16671 5.55943 8.16671 5.25001C8.16671 4.94059 8.04379 4.64384 7.825 4.42505C7.60621 4.20626 7.30946 4.08334 7.00004 4.08334C6.69062 4.08334 6.39388 4.20626 6.17508 4.42505C5.95629 4.64384 5.83337 4.94059 5.83337 5.25001Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
